import BaseUser from './base'
import DashboardUser from './dashboard'

export default DashboardUser
export { BaseUser, DashboardUser }
